import React from "react";
import { useTranslation } from "react-i18next";

import ManageEmailDomains from "~/components/Forms/DealerPassportForm/ui/ManageEmailDomains";
import Modal from "~/shared/ui/Fields/Modal";
import { OpenModal } from "~/components/Forms/DealerPassportForm/config/types";
import { useGetLocationData } from "~/hooks/locationData";

type Props = {
  handleCloseModal;
  oneDealerId;
};
const ManageEmailDomainsModal = ({ handleCloseModal, oneDealerId }: Props) => {
  const { openModal } = useGetLocationData();
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={openModal === OpenModal.MANAGEDOMAINS}
      title={t("dealers.domains_control")}
      actionClose={handleCloseModal}
    >
      <ManageEmailDomains
        dealerId={oneDealerId}
        handleCloseModal={handleCloseModal}
      />
    </Modal>
  );
};

export default ManageEmailDomainsModal;
